import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Box, Flex, Heading } from 'rebass/styled-components'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import PropTypes from 'prop-types'
import { get } from 'lodash'

import ExploreCard from './ExploreCard'

const ExploreSection = ({ livechat, liveblog, cdp }) => {
  const { t } = useTranslation('comoon')
  const images = useStaticQuery(graphql`
    query {
      live_blog: file(relativePath: { eq: "comoon/live_blog.svg" }) {
        publicURL
      }
      live_chat: file(relativePath: { eq: "comoon/live_chat.svg" }) {
        publicURL
      }
      content_wall: file(relativePath: { eq: "comoon/content_wall.svg" }) {
        publicURL
      }
      cdp: file(relativePath: { eq: "comoon/cdp.svg" }) {
        publicURL
      }
    }
  `)

  const liveBlog = get(images, 'live_blog.publicURL')
  const liveChat = get(images, 'live_chat.publicURL')
  const contentWall = get(images, 'content_wall.publicURL')
  const cdpImage = get(images, 'cdp.publicURL')

  return (
    <Box as="section" pt={30}>
      <Heading mb={[12, 15]} px={[5, 5, 0]} variant="level2" textAlign="center">
        {t('explore.title')}
      </Heading>

      <Box
        mt={['1060px', '1060px', '230px']}
        sx={{
          backgroundImage: 'url(/purpleBg.png)',
          backgroundPosition: 'bottom center',
          backgroundRepeat: 'repeat-y',
          backgroundSize: 'cover'
        }}
      >
        <Flex
          flexDirection={['column', 'column', 'row']}
          alignItems={['center', 'center', 'flex-start']}
          justifyContent="space-between"
          maxWidth="container"
          height={['264px', '264px', 'auto']}
          mx="auto"
          px={[5, 5, 0]}
          pb={25}
        >
          <ExploreCard
            to={livechat ? `/products/live-blog` : `/products/live-chat`}
            type={livechat ? 'live_blog' : 'live_chat'}
            src={livechat ? liveBlog : liveChat}
          />

          <ExploreCard
            to={livechat || liveblog ? '/products/content-wall' : '/products/live-blog'}
            type={livechat || liveblog ? 'content_wall' : 'live_blog'}
            src={livechat || liveblog ? contentWall : liveBlog}
          />

          <ExploreCard
            to={cdp ? `/products/content-wall` : `/products/cdp`}
            type={cdp ? 'content_wall' : 'cdp'}
            src={cdp ? contentWall : cdpImage}
          />
        </Flex>
      </Box>
    </Box>
  )
}

ExploreSection.propTypes = {
  livechat: PropTypes.bool,
  cdp: PropTypes.bool,
  liveblog: PropTypes.bool
}

export default ExploreSection
